import { useState } from "react";
import { Carousel } from "react-bootstrap";
import { Link } from "react-router-dom";
import bannerVideo from "../../videos/banner_video.mp4";
import img1 from "../../components/slider-1.jpg";
import img2 from "../../components/slider-2.jpg";
import img3 from "../../components/slider-3.jpg";

function BannerSlider() {
  const [index, setIndex] = useState(0);
  
  // 1. Add state to track if the video is currently playing
  // We initialize it to true because the video has the "autoPlay" attribute
  const [isVideoPlaying, setIsVideoPlaying] = useState(true);

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };

  // 2. Event handlers for the video
  const handleVideoPlay = () => setIsVideoPlaying(true);
  const handleVideoPause = () => setIsVideoPlaying(false);
  const handleVideoEnded = () => {
    setIsVideoPlaying(false);
    setIndex(1); // Move to the next slide when finished
  };

  return (
    <>
      <div className="banner-slider">
        {/* 3. Pause the interval ONLY if we are on the first slide AND the video is playing */}
        <Carousel 
          fade 
          activeIndex={index} 
          onSelect={handleSelect} 
          interval={(index === 0 && isVideoPlaying) ? null : 5000}
        >
          <Carousel.Item>
            <img className="banner-slider-image" src={img1} alt="First slide" />
            <Carousel.Caption style={{ marginBottom: 85 }}>
              <div className="container">
                <div className="row justify-content-center">
                  <div className="col-lg-8 col-md-12">
                    {/* 4. Attach the play, pause, and ended events to the video */}
                    <video 
                      className="w-100" 
                      autoPlay 
                      muted 
                      controls 
                      onPlay={handleVideoPlay}
                      onPause={handleVideoPause}
                      onEnded={handleVideoEnded}
                    >
                      <source src={bannerVideo} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  </div>
                </div>
              </div>
            </Carousel.Caption>
          </Carousel.Item>
          
          <Carousel.Item>
            <img className="banner-slider-image" src={img1} alt="Second slide" />
            <Carousel.Caption>
              <div className="col-lg-7">
                <div className="tp-hero-content p-relative">
                  <div className="tp-hero-title-wrapper">
                    <h2 className="tp-hero-title">Protect yourself</h2>
                    <p>
                      Protecting the head of the family financially is crucial
                      for ensuring stability and security. Have you planned any
                      of these Emergency Fund, Insurance Coverage, Financial
                      Planning, Diversified Investment, Estate Planning,
                      Education Career development, Legal Protection. Don’t
                      worry if you have not done anything we are here to help to
                      start protecting yourself
                    </p>
                  </div>
                  <div className="tp-hero-button-wrapper d-flex flex-wrap align-items-center">
                    <div className="tp-hero-btn mr-30">
                      <Link className="tp-btn" to="/ContactUs">
                        Contact Us
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </Carousel.Caption>
          </Carousel.Item>

          <Carousel.Item>
            <img
              className="banner-slider-image"
              src={img2}
              alt="Third slide"
            />
            <Carousel.Caption>
              <div className="col-lg-7">
                <div className="tp-hero-content p-relative">
                  <div className="tp-hero-title-wrapper">
                    <h2 className="tp-hero-title">Protect your family</h2>
                    <p>
                      Protecting your family financially involves various
                      strategies to ensure stability, security, and resilience
                      in the face of unexpected events or financial challenges.
                      We are here to help guide you to start protecting your
                      family
                    </p>
                  </div>
                  <div className="tp-hero-button-wrapper d-flex flex-wrap align-items-center">
                    <div className="tp-hero-btn mr-30">
                      <Link className="tp-btn" to="/ContactUs">
                        Contact Us
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </Carousel.Caption>
          </Carousel.Item>
          
          <Carousel.Item>
            <img className="banner-slider-image" src={img3} alt="Fourth slide" />
            <Carousel.Caption>
              <div className="col-lg-7">
                <div className="tp-hero-content p-relative">
                  <div className="tp-hero-title-wrapper">
                    <h2 className="tp-hero-title">Reduce Debt</h2>
                    <p>
                      Develop a plan to manage and reduce debt. Prioritize
                      high-interest debt for repayment and explore strategies
                      such as debt consolidation or refinancing to lower
                      interest rates and streamline payments.
                    </p>
                    <p>
                      Review your financial plan regularly and make adjustments
                      as needed based on changes in your life circumstances,
                      financial goals, market conditions, and tax laws. Stay
                      proactive and flexible to adapt to evolving financial
                      needs and opportunities
                    </p>
                  </div>
                  <div className="tp-hero-button-wrapper d-flex flex-wrap align-items-center">
                    <div className="tp-hero-btn mr-30">
                      <Link className="tp-btn" to="/ContactUs">
                        Contact Us
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </Carousel.Caption>
          </Carousel.Item>
          
          <Carousel.Item>
            <img className="banner-slider-image" src={img1} alt="Fifth slide" />
            <Carousel.Caption>
              <div className="col-lg-7">
                <div className="tp-hero-content p-relative">
                  <div className="tp-hero-title-wrapper">
                    <h2 className="tp-hero-title">Build Wealth</h2>
                    <p>
                      Passive income is no longer just an option; it's a
                      priority, especially given the current inflation
                      circumstances. We can assist you in exploring new business
                      opportunities with absolutely no initial capital, allowing
                      you to start building wealth
                    </p>
                  </div>
                  <div className="tp-hero-button-wrapper d-flex flex-wrap align-items-center">
                    <div className="tp-hero-btn mr-30">
                      <Link className="tp-btn" to="/ContactUs">
                        Contact Us
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </Carousel.Caption>
          </Carousel.Item>

          <Carousel.Item>
            <img
              className="banner-slider-image"
              src={img2}
              alt="Sixth slide"
            />
            <Carousel.Caption>
              <div className="col-lg-7">
                <div className="tp-hero-content p-relative">
                  <div className="tp-hero-title-wrapper">
                    <h2 className="tp-hero-title">Retirement Planning</h2>
                    <p>
                      Estimate your retirement needs and develop a plan to
                      accumulate sufficient savings for retirement.{" "}
                    </p>
                    <p>
                      Contribute regularly to retirement accounts such as
                      401(k)s, IRAs, or pensions, and consider employer matching
                      contributions. We are here to help guide you to start
                      retirement planning
                    </p>
                  </div>
                  <div className="tp-hero-button-wrapper d-flex flex-wrap align-items-center">
                    <div className="tp-hero-btn mr-30">
                      <Link className="tp-btn" to="/ContactUs">
                        Contact Us
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </Carousel.Caption>
          </Carousel.Item>
          
          <Carousel.Item>
            <img className="banner-slider-image" src={img3} alt="Seventh slide" />
            <Carousel.Caption>
              <div className="col-lg-7">
                <div className="tp-hero-content p-relative">
                  <div className="tp-hero-title-wrapper">
                    <h2 className="tp-hero-title">Estate Planning</h2>
                    <p>
                      Create an estate plan to ensure that your assets are
                      distributed according to your wishes and minimize taxes
                      and legal fees.{" "}
                    </p>
                    <p>
                      Establish a will or trust, designate beneficiaries for
                      retirement accounts and life insurance policies, and
                      consider strategies to transfer wealth efficiently. We are
                      here to help guide you to start estate planning
                    </p>
                  </div>
                  <div className="tp-hero-button-wrapper d-flex flex-wrap align-items-center">
                    <div className="tp-hero-btn mr-30">
                      <Link className="tp-btn" to="/ContactUs">
                        Request a Quote
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </Carousel.Caption>
          </Carousel.Item>
        </Carousel>
      </div>
    </>
  );
}

export default BannerSlider;